var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    width: "20px",
    height: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3215F",
    d: "M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M9.5,15.8c-0.7,0-1.3-0.5-1.3-1.3 c0-0.8,0.6-1.3,1.4-1.3c0.8,0,1.3,0.6,1.3,1.4C10.9,15.4,10.3,15.9,9.5,15.8z M13.1,8.9c-0.2,0.3-0.6,0.6-1.1,1l-0.6,0.4 c-0.3,0.2-0.5,0.5-0.6,0.8c0,0.2-0.1,0.6-0.1,0.8c0,0.1,0,0.2-0.2,0.2s-1.6,0-1.7,0S8.6,12,8.6,11.9c0-0.7,0.1-1.4,0.4-1.8 c0.4-0.7,1.6-1.4,1.6-1.4c0.2-0.1,0.3-0.3,0.4-0.4c0.2-0.3,0.4-0.6,0.4-0.9c0-0.4-0.1-0.7-0.3-1c-0.3-0.3-0.6-0.5-1.2-0.5 C9.3,5.9,9,6.2,8.8,6.5C8.5,6.9,8.6,7.4,8.6,7.8H6.4c0-1.5,0.4-2.5,1.2-3.1c0.6-0.4,1.3-0.6,2.1-0.6c1.1,0,2,0.2,2.8,0.8 c0.7,0.5,1.1,1.3,1.1,2.3C13.6,7.9,13.4,8.5,13.1,8.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4af5c9ef042ab96d3512c041672a64b7.svg";
export { ForwardRef as ReactComponent };